/* eslint-disable react/button-has-type */
import * as React from "react";
import RespondInviteGroupContainer from "./RespondInviteGroupContainer";
import { Modal, Button } from "react-bootstrap";
import { Icon, ICONS } from "../../Icons";
import "./css/respondInviteGroup.scss";

class RespondInviteGroupModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: {}
    };
  }

  onSave() {
    if (this.validate()) {
      this.props.onAction(this.props.onSave, this.props.model).then(() => {
        this.props.onClose(true);
      });
    }

    this.setState({
      isSubmitted: true
    });
  }

  onRespondInvite = (response) => {
    const { groupId, groupType } = this.props.model;
    this.props
      .onAction(this.props.onRespondInvite, groupId, groupType, response)
      .then(() => {
        this.props.onClose(true);
      });
  }

  onClose = () => {
    this.props.onClose(true);
  }

  render() {
    return (
      <Modal show={true} className="general-modal respond-invite-point">
        <Modal.Header>
          <Button bsStyle="link" className="btn-close" onClick={this.onClose}>
            <Icon icon={ICONS.CLOSE} />
          </Button>
          <div className="modal-title">
            <Icon icon={ICONS.INVITE} /> You've been invited you to this Group
          </div>
        </Modal.Header>
        <Modal.Body>
          <RespondInviteGroupContainer />
        </Modal.Body>
        <Modal.Footer>
          <div className="footrBtn">
            <button
              onClick={() => this.onRespondInvite("rejected")}
              className="btn btn-outline btn-md btn-reject"
            >
              Decline
            </button>
            <button
              onClick={() => this.onRespondInvite("accepted")}
              className="btn btn-primary btn-outline btn-md btn-accept"
            >
              Accept
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RespondInviteGroupModal;
